<style>
      @font-face {
        font-family: "MyFont";
        src: url('../src/assets/Font/font.TTF');
      }
</style>
<template>
    <div id="app"> <router-view/> </div>
</template>
<script>
export default {
    mounted() {
        // 判断设备
        if (/mobile/i.test(navigator.userAgent) == true) {
            // 手机
            this.$router.replace('Phone')
        }
        else{
            // pc
            this.$router.replace('/')
        }
    },
}
</script>
